import { ApplicationElement, html } from '@crossiety/lit-components';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import style from './style.lit.css';

import '@crossiety/lit-components/components/img_placeholder/element.js';
import '@crossiety/lit-components/components/badge/element.js';

/**
 * Component that links to a group or a group-joining page. The text below the image should be passed as a child(innerText).
 *
 * @prop count - Number of group related notifications
 * @prop favorite - Is the group among user favorites? Will render a star in top-left corner if set to true
 * @prop picture - Groups picture URL
 * @prop href - The whole element will link to this URL
 * @prop placeholder - Is this element representing a real group(default) or a placeholder(for eg. join a new group -> placeholder='true')
 * @prop name - Will be derived from the innerText of the element and will be passed as avatar components name, which will than be used to make an image with initials if no picture is present.
 *
 * @slot default - For group name
 *
 * @cssprop --avatar-size - Avatar size
 * @cssprop --link-text-active - Active link color
 */
export default class GroupItem1 extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    count: { type: Number },
    favorite: { type: Boolean },
    picture: { type: String },
    href: { type: String },
    placeholder: { type: Boolean },
    name: { state: true },
  };

  onSlotChange() {
    this.name = this.innerText;
  }

  renderFavorite() {
    return html`<ef-icon name="star:solid"></ef-icon>`;
  }

  renderGroupAvatar() {
    return html`
      <ef-img-placeholder
        picture=${ifDefined(this.picture)}
        alt=${ifDefined(this.name)}>
      </ef-img-placeholder>
    `;
  }

  renderPlaceholder() {
    return html`<div class="placeholder"><ef-icon name="plus"></ef-icon></div>`;
  }

  render() {
    return html`
      <a href=${this.href} class=${classMap({ favorite: this.favorite })}>
        ${this.placeholder
          ? this.renderPlaceholder()
          : this.renderGroupAvatar()}
        <ef-badge count=${this.count} theme="danger"></ef-badge>
        ${this.favorite ? this.renderFavorite() : null}
        <slot @slotchange=${this.onSlotChange}></slot>
      </a>
    `;
  }
}

customElements.get('xs-group-item-1') ||
  customElements.define('xs-group-item-1', GroupItem1);
